var map = {
	"./Tabulator.png": 925,
	"./airtable.svg": 316,
	"./appwrite.svg": 223,
	"./aurora.svg": 926,
	"./chatgpt-logo.png": 802,
	"./claudeai.svg": 1067,
	"./database.svg": 1068,
	"./deepseekai.svg": 1069,
	"./directus.svg": 224,
	"./drapcode.png": 927,
	"./firebase-cloud-firestore.svg": 1070,
	"./firebase-cloud-function.svg": 1071,
	"./firebase-database.svg": 1072,
	"./firebase-realtime-database.svg": 1073,
	"./firebase.svg": 1074,
	"./google-sheets-white.svg": 1075,
	"./google-sheets.svg": 1076,
	"./integromat.svg": 1077,
	"./mariadb.svg": 928,
	"./ms-sql-server.svg": 929,
	"./mysql.svg": 930,
	"./notion.svg": 1078,
	"./oAuth2-logo.svg": 1079,
	"./openai.svg": 1080,
	"./oracledb.svg": 931,
	"./postgresql.svg": 932,
	"./rocket.svg": 933,
	"./salesforce.svg": 317,
	"./sqlite.svg": 934,
	"./supabase.svg": 225,
	"./xano.svg": 226,
	"./xata.svg": 318,
	"./zapier.svg": 248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;